import React, { Component } from 'react'
import { Route, Redirect, Switch, BrowserRouter as Router } from 'react-router-dom'
import * as Sentry from '@sentry/browser';

import './App.css'
import { PaginationContext } from '../context/pagination'
import Pagination from './pagination/pagination'
import Logo from './common/logo'
import Registration from './registration'
import Welcome from './welcome'
import Questionnaire from './questionnaire'
import Landing from './landing'
import Invite from './invite'
import Screener from './screener'
import Assessment from './assessment'
import Profile from './personal_profile'
import Coaching from './coaching'
import ErrorPage from './error/error'
import Footer from './common/footer'
import config from '../utils/config'
import AppInfo from "../utils/version.json"
import LiveAgent from './common/liveagent'
import FetchWrapper from '../utils/fetch_wrapper'
import queryString from 'query-string'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pagination: [
        { path: '/register', numPages: Registration.getPageCount(), activePage: 0 },  
        { path: '/welcome', numPages: Welcome.getPageCount(true), activePage: 0 },
        { path: '/questionnaire', numPages: Questionnaire.getPageCount(), activePage: 0 },
        { path: '/coaching', numPages: Coaching.getPageCount(), activePage: 0 },
      ],
      profilePagination: [
        { path: '/profile', numPages: Profile.getPageCount(), activePage: 0 }
      ],
      path: '',
      stepCompleted: null,
      nextStepPath: null,
      shouldRedirect: false,
      removeJWT: false,
      dataInitialised: false,
      registrationPagesLogoImage: null,
      contactInfoCustomText: null,
      displayGenetics: true,
      welcomeVideo: null,
      collectEmail: false,
      UseVerificationCode: false,
      UseDOBForVerification: false,
      UseNameForVerification: false,
      VerificationPageDescription: null,
      UseLeadingZeros: false,
      VerificationPageInstructions: null,
      VerificationPageTitle: null,
      UseEmployeeSpouseSelection: false,
      SelectEmployeeButtonLabel: null,
      SelectSpouseButtonLabel: null,
      ValidateOn: null,
      forcePaginationRender: false
    }
    this.setShouldRedirect = this._setShouldRedirect.bind(this)
    this.getStepCompleted = this._getStepCompleted.bind(this)
    this.updateActivePage = this._updateActivePage.bind(this)
    this.getClientData = this._getClientData.bind(this)
    this.initializeLiveAgentScripts = this._initializeLiveAgentScripts.bind(this)
    this.header = this._header.bind(this)
    this.footer = this._footer.bind(this)
  }

  async componentDidMount() {
    await this.initializeLiveAgentScripts(config.liveAgentDeploymentScript)
    await this.initializeLiveAgentScripts(config.liveAgentPreChatScript)
    Sentry.init({
      dsn: 'https://bf7add4360314b11b77407f75ae5be20@o327444.ingest.sentry.io/5874639',
      environment: AppInfo.env,
      release: AppInfo.version,
    })
    const response = await this.getClientData()
    if (!response) {
      this.props.error()
    }
  }

  _updateActivePage(path, activePage) {
    let newState = this.state
    if (path === '/profile') {
      newState = { ...this.state,
        profilePagination: this.state.profilePagination.map(page => 
          page.path === path ? { ...page, activePage } : page
        ),
        forcePaginationRender: true,
        path
      }
    } else {
      newState = { ...this.state,
        pagination: this.state.pagination.map(page => 
          page.path === path ? { ...page, activePage } : page
        ),
        forcePaginationRender: true,
        path
      }
    }
    this.setState(newState)
  }

  _nextPage(history, path, param) {
    let newPath = path
    if (param) {
      newPath = path + '/' + param
    }
    switch(newPath) {
      case '/landing':
        return history.push('/register/1' + window.location.search)
      case '/screener':
        return history.push('/register/1' + window.location.search)
      case '/JPMC':
        return history.push('/register/1?regCode=JPMC')
      case '/register':
        return history.push('/welcome' + window.location.search)
      case '/welcome':
        return history.push('/questionnaire' + window.location.search)
      case '/questionnaire':
        return history.push('/coaching/1' + window.location.search)
      case '/coaching':
        return history.push('/profile/1' + window.location.search)
      default: return null
    }
  }

  _errorPage(history) {
    return history.replace('/error')
  }
  
  extendRoute(R) {
    return props => {
      return <R 
        {...props} 
        updateActivePage={this.updateActivePage}
        next={this._nextPage.bind(this, props.history, props.match.path)}
        error={this._errorPage.bind(this, props.history)}
        getStepCompleted={this.getStepCompleted}
        getClientData={this.getClientData}
        stepCompleted={this.state.stepCompleted}
        setShouldRedirect={this.setShouldRedirect}
        nextStepPath={this.state.nextStepPath ? this.state.nextStepPath.replace(window.location.origin, '') : null}
        registrationPagesLogoImage={this.state.registrationPagesLogoImage}
        displayGenetics={this.state.displayGenetics}
        welcomeVideo={this.state.welcomeVideo}
        collectEmail={this.state.collectEmail}
        UseVerificationCode={this.state.UseVerificationCode}
        UseDOBForVerification={this.state.UseDOBForVerification}
        UseNameForVerification={this.state.UseNameForVerification}
        VerificationPageDescription={this.state.VerificationPageDescription}
        UseLeadingZeros={this.state.UseLeadingZeros}
        VerificationPageInstructions={this.state.VerificationPageInstructions}
        VerificationPageTitle={this.state.VerificationPageTitle}
        UseEmployeeSpouseSelection={this.state.UseEmployeeSpouseSelection}
        SelectEmployeeButtonLabel={this.state.SelectEmployeeButtonLabel}
        SelectSpouseButtonLabel={this.state.SelectSpouseButtonLabel}
        ValidateOn={this.state.ValidateOn}
      />
    }
  }

  async _getStepCompleted(plId) {
    try {
      let response = await FetchWrapper.fetch(config.endpoint_get_stepcompleted + '&plId=' + plId, {
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include'
      })

      const { data } = response
      let newState = { ...this.state,
        stepCompleted: data.Registration_Step_Completed,
        nextStepPath: data.Personal_Profile_URL
      }
      if (this.state.nextStepPath !== newState.nextStepPath) {
        this.setState(newState)
      }
      this.setShouldRemoveJWT()
      return newState.nextStepPath.replace(window.location.origin, '')
    }
    catch(error) {
      if (error.message === 'Participant Next Step URL not found') {
        return error
      }
      this.setShouldRedirect(true)
      return false
    }
  }

  async _initializeLiveAgentScripts(src) {
    const deploymentScript = document.createElement('script');
    deploymentScript.src = src;
    deploymentScript.referrerpolicy = 'no-referrer';
    deploymentScript.type = 'text/javascript';
    deploymentScript.async = true;
    document.body.appendChild(deploymentScript);
  }

  async _getClientData() {
    let paths = ["landing", "register", "welcome", "questionnaire","coaching", "profile", "invite", "JPMC"];
    const path = window.location.pathname.split('/')[1]
    let regCode = path
    if (paths.includes(path)) {
      regCode = queryString.parse(window.location.search).regCode
    }
    try {
      let response = await FetchWrapper.fetch(config.endpoint_getClientData + '&regCode=' + regCode, {
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      })
      
      const { data } = response
      this.setState({ ...this.state,
        registrationPagesLogoImage: data.RegistrationPagesLogoImage,
        contactInfoCustomText: data.ContactInfoCustomText,
        welcomeVideo: data.WelcomeVideo,
        displayGenetics: data.DisplayGenetics === 'true',
        collectEmail: data.CollectEmail === 'true',
        UseVerificationCode: data.UseVerificationCode === 'true',
        UseDOBForVerification: data.UseDOBForVerification === 'true',
        UseNameForVerification: data.UseNameForVerification === 'true',
        VerificationPageDescription: data.VerificationPageDescription,
        UseLeadingZeros: data.UseLeadingZeros === 'true',
        UseEmployeeSpouseSelection: data.UseEmployeeSpouseSelection === 'true',
        VerificationPageInstructions: data.VerificationPageInstructions,
        VerificationPageTitle: data.VerificationPageTitle,
        SelectEmployeeButtonLabel: data.SelectEmployeeButtonLabel,
        SelectSpouseButtonLabel: data.SelectSpouseButtonLabel,
        ValidateOn: data.ValidateOn,
        dataInitialised: true,
        pagination: [
          { path: '/register', numPages: Registration.getPageCount(), activePage: 0 },  
          { path: '/welcome', numPages: Welcome.getPageCount(data.DisplayGenetics === 'true'), activePage: 0 },
          { path: '/questionnaire', numPages: Questionnaire.getPageCount(), activePage: 0 },
          { path: '/coaching', numPages: Coaching.getPageCount(), activePage: 0 },
        ],
        loading: false
      })
    }
    catch(e) {
      this.setState({ ...this.state,
        dataInitialised: true
      })
    }
    return true
  }

  setShouldRemoveJWT() {
    const jwt = queryString.parse(window.location.search).jwt
    if (jwt && !this.state.removeJWT) {
      this.setState({ removeJWT: true })
    }
  }

  _setShouldRedirect(value) {
    if (value !== this.state.shouldRedirect) {
      this.setState({ shouldRedirect: value })
      return true
    }
    return false
  }

  redirect() {
    return props => {
      if (this.state.removeJWT) {
        const queryParams = queryString.parse(window.location.search)
        delete queryParams.jwt
        const newSearch = queryString.stringify(queryParams)
        return <Redirect to={window.location.pathname + '?' + newSearch} />
      }
      if (this.state.shouldRedirect && this.state.nextStepPath) {
        return <Redirect push to={this.state.nextStepPath.replace(window.location.origin, "")} />
      }
      return null
    }
  }

  _header() {
    return (
      <div className="container header">
        <Pagination />        
        <Logo 
          registrationPagesLogoImage={this.state.registrationPagesLogoImage}
        />
      </div>
    )
  }

  _footer() {
    return (
      <Footer
        contactInfoCustomText={this.state.contactInfoCustomText}
      />
    )
  }

  render() {
    if (!this.state.dataInitialised) { 
      return (
        <div></div>
      )
    }
    let paginationState = {}
    if (this.state.path === '/profile') {
      paginationState = {
        state: this.state.profilePagination,
        updateActivePage: this.updateActivePage,
        path: this.state.path
      }
    } else {
      paginationState = {
        state: this.state.pagination,
        updateActivePage: this.updateActivePage,
        path: this.state.path,
        forcePaginationRender: this.state.forcePaginationRender
      }
    }
    if (this.state.forcePaginationRender) {
      this.setState({ forcePaginationRender: false })
    }
    return (
      <div>
        <PaginationContext.Provider value={paginationState}>
          <Router>
            <div>
              <Route path="/" render={this.redirect()}/>
              <Route path={`/(register|questionnaire|welcome|profile|coaching)`} component={this.header}/>
              <Switch>
                <Route path="/landing" render={this.extendRoute(Landing)} />
                <Route path="/screener" render={this.extendRoute(Screener)} />
                <Route path="/register" render={this.extendRoute(Registration)} />
                <Route path="/welcome" render={this.extendRoute(Welcome)} />
                <Route path="/questionnaire" render={this.extendRoute(Questionnaire)} />
                <Route path="/profile" render={this.extendRoute(Profile)} />
                <Route path="/coaching" render={this.extendRoute(Coaching)} />
                <Route path="/invite" render={this.extendRoute(Invite)} />
                <Route path="/error" render={this.extendRoute(ErrorPage)} />
                <Redirect path="/JPMC" to="/register/1?regCode=JPMC"/>
                <Redirect path="/JPMC-PilotTest" to="/register/1?regCode=JPMCPILOT"/>
                <Redirect from="/:client/1" to="/landing?regCode=:client" />
                <Redirect from="/:client" to="/landing?regCode=:client" />
              </Switch>
              <Route path={"/(register|questionnaire|welcome|profile|landing|coaching|invite|JPMC)"} component={this.footer}/>
            </div>
          </Router>
        </PaginationContext.Provider>
        <LiveAgent />
      </div>
    )
  }
}
export default App